/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FactorBrokerEmailMessage } from '../../models/factor-broker-email-message';
import { FactorBrokerEmailMessagePagedResult } from '../../models/factor-broker-email-message-paged-result';

export interface MonitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Params {
  pageNumber?: number;
  pageSize?: number;
      body?: FactorBrokerEmailMessage
}

export function monitorSearchEmailMessagesSearchEmailMessagesPost$Plain(http: HttpClient, rootUrl: string, params?: MonitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<FactorBrokerEmailMessagePagedResult>> {
  const rb = new RequestBuilder(rootUrl, monitorSearchEmailMessagesSearchEmailMessagesPost$Plain.PATH, 'post');
  if (params) {
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FactorBrokerEmailMessagePagedResult>;
    })
  );
}

monitorSearchEmailMessagesSearchEmailMessagesPost$Plain.PATH = '/Monitor/SearchEmailMessages/search-email-messages';
